// extracted by mini-css-extract-plugin
export var table = "styles-module--table--62f36";